/* Mqamis : emballages automatiques (sacs d'envoi + cartons parfum).
   Ajoutés au panier à 0 €, recalculés à chaque changement du panier et avant le paiement.
   Règle : 1 sac par article (qamis, qamis sur mesure, iqal, ensemble, autres) ;
   0 sac pour chéchia, veste, manteau, carte cadeau, tissu sur mesure ;
   parfums : 1 carton par parfum, 0 sac. */
(function () {
  var C = window.mqEmballages || {};
  var SAC = Number(C.sac), CARTON = Number(C.carton);
  if (!SAC || !CARTON || !window.fetch || window.__mqEmb) return;
  window.__mqEmb = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ZERO = /(ch[eé]ch[iy]a|veste|manteau|carte[\s-]*cadeau|gift\s*card|tissu sur mesure)/i;
  var PARFUM = /parfum/i;
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var chain = Promise.resolve();

  function besoin(items) {
    var s = 0, c = 0;
    items.forEach(function (it) {
      if (it.variant_id === SAC || it.variant_id === CARTON) return;
      var type = String(it.product_type || ''), titre = String(it.product_title || '');
      if (/emballage/i.test(type) || it.gift_card) return;
      if (ZERO.test(type) || ZERO.test(titre)) return;
      if (PARFUM.test(type)) { c += it.quantity; return; }
      s += it.quantity;
    });
    return { s: s, c: c };
  }
  function present(items, id) {
    return items.reduce(function (n, it) { return it.variant_id === id ? n + it.quantity : n; }, 0);
  }
  function json(url, opts) { return nativeFetch(url, opts).then(function (r) { return r.json(); }); }
  function inner(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var el = d.querySelector(sel);
    return el ? el.innerHTML : null;
  }

  function etiqueter() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      if (!row.querySelector('a[href*="/products/emballage-"]')) return;
      var cell = row.querySelector('.cart-item__quantity'), q = row.querySelector('.quantity__input');
      if (!cell || !q || cell.querySelector('.mq-emb-qty')) return;
      var s = document.createElement('span');
      s.className = 'mq-emb-qty';
      s.textContent = '× ' + q.value + ' · offert';
      cell.insertBefore(s, cell.firstChild);
    });
  }

  function rafraichir() {
    var mci = document.getElementById('main-cart-items');
    var drawer = document.querySelector('cart-drawer');
    var ids = ['cart-icon-bubble'];
    if (mci && mci.dataset.id) ids.push(mci.dataset.id);
    if (drawer) ids.push('cart-drawer');
    return json(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' }).then(function (s) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var h1 = inner(s['cart-icon-bubble'], '.shopify-section');
        if (h1 !== null) bubble.innerHTML = h1;
      }
      if (mci && s[mci.dataset.id]) {
        var t2 = mci.querySelector('.js-contents'), h2 = inner(s[mci.dataset.id], '.js-contents');
        if (t2 && h2 !== null) t2.innerHTML = h2;
      }
      if (drawer && s['cart-drawer']) {
        var t3 = document.getElementById('CartDrawer'), h3 = inner(s['cart-drawer'], '#CartDrawer');
        if (t3 && h3 !== null) {
          t3.innerHTML = h3;
          var ov = document.getElementById('CartDrawer-Overlay');
          if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
        }
      }
      etiqueter();
    });
  }

  function verifier() {
    return json(root + 'cart.js', { credentials: 'same-origin' }).then(function (cart) {
      var b = besoin(cart.items), u = {}, change = false;
      if (present(cart.items, SAC) !== b.s) { u[SAC] = b.s; change = true; }
      if (present(cart.items, CARTON) !== b.c) { u[CARTON] = b.c; change = true; }
      if (!change) return;
      return json(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: u })
      }).then(rafraichir);
    }).catch(function (e) { if (window.console) console.warn('[mq-emballages]', e); });
  }
  function sync() { chain = chain.then(verifier, verifier); return chain; }

  // Après chaque ajout / modification du panier faite par le thème
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function () { setTimeout(sync, 60); }, function () {});
    return p;
  };

  // Dernière vérification juste avant le paiement
  var pret = false;
  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (pret || !b || b.name !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    b.setAttribute('aria-disabled', 'true');
    sync().then(function () {
      pret = true;
      var f = e.target;
      if (f.requestSubmit) { try { f.requestSubmit(b); return; } catch (x) {} }
      window.location.href = root + 'checkout';
    });
  }, true);

  var tm;
  new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(etiqueter, 30); })
    .observe(document.body, { childList: true, subtree: true });
  etiqueter();
  sync();
})();